const DefaultServerGridOptions = {
  defaultColDef: {
    resizable: true,
    sortable: true,
    filter: true,
    suppressMovable: false,
    enablePivot: false
  },
  sideBar: {
    toolPanels: ['columns', 'filters'],
    defaultToolPanel: false
  }
};


const DefaultGridOptions = {
  defaultColDef: {
    // allow every column to be aggregated
    enableValue: true,
    // allow every column to be grouped
    enableRowGroup: true,
    // allow every column to be pivoted
    enablePivot: true,
    sortable: true,
    filter: true,
    resizable: true,
    suppressMovable: false
  },
  sideBar: {
    toolPanels: ['columns', 'filters'],
    defaultToolPanel: false
  }
};


export {DefaultGridOptions, DefaultServerGridOptions}